import React from "react";
import CountUp from "react-countup";

function Counter() {
    return (
        <section className="stats-wrapper">
            <div className="container">
                <div className="stats-section">
                    <div className="stat-item">
                        {/* <i className="bi bi-building"></i> */}
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/established.png" className="img-fluid" />
                        <div>
                            <h3>
                                <CountUp end={1971} duration={3} separator="" />
                            </h3>
                            <p>Established</p>
                        </div>
                    </div>
                    <div className="stat-item">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/students.png" className="img-fluid" />
                        <div>
                            <h3>
                                <CountUp end={500} duration={3} separator="," />+
                            </h3>
                            <p>Students</p>
                        </div>
                    </div>
                    <div className="stat-item">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Faculty.png" className="img-fluid" />
                        <div>
                            <h3>
                                <CountUp end={50} duration={3} />+
                            </h3>
                            <p>Faculty</p>
                        </div>
                    </div>
                    <div className="stat-item">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/excellence.png" className="img-fluid" />
                        <div>
                            <h3>
                                <CountUp end={100} duration={3} />%
                            </h3>
                            <p>Excellence</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Counter;